export default function WhyChooseUs() {
  const reasons = [
    {
      number: '01',
      title: 'Deneyim',
      description: '15+ yıllık sektör tecrübesi ve binlerce mutlu müşteri',
    },
    {
      number: '02',
      title: 'Kalite',
      description: 'Orijinal yedek parça kullanımı ve garantili işçilik',
    },
    {
      number: '03',
      title: 'Teknoloji',
      description: 'Son model teşhis ve onarım ekipmanları',
    },
    {
      number: '04',
      title: 'Güven',
      description: 'Şeffaf fiyatlandırma ve müşteri memnuniyeti odaklı hizmet',
    },
  ];

  return (
    <section id="why-choose-us" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-3 sm:mb-4">
            Neden Bizi Tercih Etmelisiniz?
          </h2>
          <p className="font-sans text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            Aracınız için en iyi hizmeti sunuyoruz
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group text-center p-6 sm:p-8 border border-gray-200 hover:border-accent-gold transition-all duration-300"
            >
              <div className="font-sans text-4xl sm:text-5xl font-light text-gray-300 group-hover:text-accent-gold transition-colors mb-4 sm:mb-6">
                {reason.number}
              </div>
              <h3 className="font-sans text-xl sm:text-2xl font-semibold text-gray-900 mb-2 sm:mb-3">
                {reason.title}
              </h3>
              <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}